<template>
    <div>
        <e-form size="small" label-width="150px" ref="form">
            <template slot="item">
                <el-form-item label="打印机"
                              label-width="150px">
                    <printer :template-id="this.templateId"></printer>
                </el-form-item>
            </template>
        </e-form>
    </div>
</template>

<script>
import printer from '@/comp/etao-printer.vue'

export default {
    name: 'select-printer',
    title: '选择打印机',
    props: {
    },
    components: {printer},
    methods: {
        setTemplateId (category) {
            this.templateId = category
        }
    },
    data () {
        return {
            templateId: ''
        }
    },
    mounted () {
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/index/select-printer.vue